/* WOOF sticky add to cart. */
(() => {
  const bar = document.querySelector('[data-ds-satc]');
  if (!bar || bar.dataset.dsReady) return;
  bar.dataset.dsReady = '1';
  const form = document.querySelector('product-form form[action*="/cart/add"]');
  const main = form && form.querySelector('[name="add"]');
  if (!main) return;
  const btn = bar.querySelector('[data-ds-satc-btn]');
  const meta = bar.querySelector('[data-ds-satc-meta]');
  const info = form.closest('.product__info-container') || document;
  const priceEl = () => info.querySelector('[id^="price-"] .price-item--sale, [id^="price-"] .price-item--regular');

  const mainLabel = () => {
    const span = main.querySelector('span');
    return (span ? span.textContent : main.textContent).trim();
  };

  const sync = () => {
    btn.textContent = mainLabel();
    btn.disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
    const parts = [];
    info.querySelectorAll('variant-selects input[type="radio"]:checked, variant-selects select').forEach((el) => {
      if (el.value) parts.push(el.value);
    });
    const p = priceEl();
    const price = p ? p.textContent.trim() : '';
    meta.textContent = [parts.join(' · '), price].filter(Boolean).join('   ');
  };

  new MutationObserver(sync).observe(main, { attributes: true, childList: true, subtree: true, characterData: true });
  const priceBox = info.querySelector('[id^="price-"]');
  if (priceBox) new MutationObserver(sync).observe(priceBox, { childList: true, subtree: true, characterData: true });
  info.addEventListener('change', () => setTimeout(sync, 60));

  /* Show only once the real button has scrolled above the viewport. */
  let ticking = false;
  const check = () => {
    ticking = false;
    const show = main.getBoundingClientRect().bottom < 0;
    if (show === bar.classList.contains('is-visible')) return;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    btn.tabIndex = show ? 0 : -1;
  };
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(check);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  check();

  btn.addEventListener('click', () => {
    if (btn.disabled) return;
    main.click();
  });

  sync();
})();
